export default __webpack_public_path__ + "static/media/physics11.e247baf2.JPG";